<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <gj-modal
          v-bind="$attrs"
          v-on="$listeners"
          :visible.sync="modalVisible"
          size="full"
          :contentStyle="{'height': '100%'}"
          :footer="false">
    <template #header>
      <span>详情  {{detail.orderId}}  
        <gj-tag v-show="detail.orderStatusName" :color="getColor(detail.orderStatusName)" type="plain">
          {{detail.orderStatusName}}
        </gj-tag>
      </span>
    </template>
    <template #content>
      <div class="gj-table-parent_flex">
        <div v-loading="baseLoading"
             style="padding-right: 0px;">
          <el-row class="content-row">
            <el-col :span="8">
              <el-row>
                <el-col :span="5" class="gj-label">仓库：</el-col>
                <el-col :span="19" class="gj-content">{{detail.warehouseName | defaultShow}}</el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-row>
                <el-col :span="6" class="gj-label">订单类型：</el-col>
                <el-col :span="18" class="gj-content">{{detail.orderType | defaultShow}}</el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-row>
                <el-col :span="5" class="gj-label">请求数量：</el-col>
                <el-col :span="19" class="gj-content">{{detail.requestQuantity | defaultShow}}</el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row class="content-row">
            <el-col :span="8">
              <el-row>
                <el-col :span="5" class="gj-label">请求总成本：</el-col>
                <el-col :span="19" class="gj-content">{{detail.baseCurrencySymbol | defaultShow}}{{detail.requestFee | defaultShow}}</el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-row>
                <el-col :span="6" class="gj-label">移除费用 <gj-help>市场币</gj-help> ：</el-col>
                <el-col :span="18" class="gj-content">{{detail.marketCurrencySymbol}}{{detail.removalMarketFee | defaultShow}}</el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-row>
                <el-col :span="5" class="gj-label">移除费用 <gj-help>美元</gj-help>：</el-col>
                <el-col :span="19" class="gj-content">{{detail.baseCurrencySymbol | defaultShow}}{{detail.removalBaseFee | defaultShow}}</el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row class="content-row">
            <el-col :span="8">
              <el-row>
                <el-col :span="5" class="gj-label">请求时间：</el-col>
                <el-col :span="19" class="gj-content">{{detail.requestTime | defaultShow}}</el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-row>
                <el-col :span="6" class="gj-label">更新时间：</el-col>
                <el-col :span="18" class="gj-content">{{detail.updateTime | defaultShow}}</el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
        <el-tabs
                :value="'1'"
                style="margin-top: 4px;"
                @tab-click="handleClick">
          <el-tab-pane label="商品信息" name="1">
            <gj-table
                    name="items"
                    :loading="baseLoading"
                    :data="items"
                    :columns="itemColumns"
                    :show-overflow="false"
                    show-summary
                    adaptParent
                    :offset-height="20">
              <template v-slot:msku="{row}">
                <div>
                  <div class="text-ellipsis-1">{{row.listingTitle | defaultShow}}</div>
                  <div class="text-ellipsis-1">{{row.msku | defaultShow}}</div>
                  <div class="text-ellipsis-1">{{row.fnsku | defaultShow}}</div>
                </div>
              </template>
            </gj-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn} from "../../../../../minxins";
  import {getRemovalShipmentDetail} from "../../../../../api/sale";
  import {tagColors} from "@/components/tag/tag-colors";

  export default {
    name: "app-view-removal-shipment-modal",
    mixins: [modalMixIn],
    props: {
      warehouseId: {
        required: true
      },
      orderId: {
        required: true
      }
    },
    data() {
      return {
        tagColors,
        baseLoading: true,
        detail: {},
        items: [],
        itemColumns: [
          {id: 'picture', header: '图片', field: 'picture:imageUrl', width: '50px'},
          {id: 'msku', header: '标题/MSKU/FNSKU', field: 'slot:msku', minWidth: '200px'},
          {id: 'disposition', header: '商品属性', field: 'disposition', minWidth: '90px'},
          {id: 'requestedQuantity', header: '请求数量', field: 'requestedQuantity', minWidth: '70px', align: 'right', summary: true},
          {id: 'cancelledQuantity', header: '已取消', field: 'cancelledQuantity', minWidth: '60px', align: 'right', summary: true},
          {id: 'disposedQuantity', header: '已弃置', field: 'disposedQuantity', minWidth: '60px', align: 'right', summary: true},
          {id: 'shippedQuantity', header: '已退回', field: 'shippedQuantity', minWidth: '60px', align: 'right', summary: true},
          {id: 'inProcessQuantity', header: '待生效', field: 'inProcessQuantity', minWidth: '60px', align: 'right', summary: true},
          {id: 'removalFee', header: '移除费用', field: 'removalFee', prefix: 'removalCurrencySymbol', minWidth: '90px', align: 'right', help: '市场币', summary: true},
          {id: 'baseRemovalFee', header: '移除费用', field: 'baseRemovalFee', prefix: 'baseCurrencySymbol', minWidth: '90px', align: 'right', help: '美元', summary: true},
          {id: 'purchaseCost', header: '采购成本', field: 'purchaseCost', prefix: 'baseCurrencySymbol', minWidth: '90px', align: 'right', help: '单个产品的采购成本', summary: true},
          {id: 'arrivalCost', header: '到库成本', field: 'arrivalCost', prefix: 'baseCurrencySymbol', minWidth: '90px', align: 'right', help: '单个产品的到库成本', summary: true},
          {id: 'requestedCost', header: '请求成本', field: 'requestedCost', prefix: 'baseCurrencySymbol', minWidth: '90px', align: 'right', help: '已取消数量不参与计算', summary: true},
          {id: 'disposedCost', header: '已弃置成本', field: 'disposedCost', prefix: 'baseCurrencySymbol', minWidth: '105px', align: 'right', summary: true, help: '已弃置数量成本金额，币种为美元，计算公式=已弃置数量*(采购成本+到库成本)'}
        ]
      };
    },
    created() {
      // 获取详情数据
      this.baseLoading = true;
      getRemovalShipmentDetail(this.warehouseId, this.orderId)
              .then((data) => {
                this.detail = data || {};
                this.items = data.items || [];
              })
              .complete(() => this.baseLoading = false);
    },
    methods: {
      handleClick() {
        const vm = this;
        this.$nextTick(() => vm.$nextTick(() => vm.items = [...vm.items]));
      },
      getColor(status){
        switch (status){
          case '处理中':
            return this.tagColors.orange
          case '已完成':
            return this.tagColors.green
          case '已取消':
            return this.tagColors.lightGray
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .gj-label {
    text-align: right;
    font-size: 12px;
    color: #666;
  }
  .gj-content{
    font-size: 12px;
  }
  .content-row {
    line-height: 32px;
  }
  /deep/ .el-tabs {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .el-tabs__content{
      flex: 1;
      overflow: auto;
    }
    .el-tab-pane{
      height: 100%;
    }
  }
</style>


